import { useState } from "react";
import { useSiteSettings } from "../../../contexts/SiteSettingsContext";

export default function SiteHeader() {
  const { settings } = useSiteSettings();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  return (
    <header className="w-full">
      <div className="w-full py-6 text-center relative overflow-hidden"
        style={{ background: "linear-gradient(135deg, #ffcde9 0%, #fae8f2 60%, #ffcde9 100%)" }}>
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(18)].map((_, i) => (
            <span key={i} className="absolute rounded-full opacity-40"
              style={{ width: `${8 + (i % 5) * 6}px`, height: `${8 + (i % 5) * 6}px`, background: "#f9a8d4",
                top: `${(i * 23) % 100}%`, left: `${(i * 37 + 10) % 100}%`, filter: "blur(4px)" }} />
          ))}
        </div>
        <div className="relative z-10">
          <p className="text-pink-400 text-xs tracking-widest mb-1">{settings.headerSubtitle}</p>
          <a href={settings.headerUrl} className="text-pink-800 text-4xl font-bold tracking-wide"
            style={{ fontFamily: "'Georgia', serif", textShadow: "0 2px 8px rgba(255,182,220,0.5)" }}>
            {settings.headerTitle}
          </a>
        </div>
      </div>

      <nav className="w-full border-b border-pink-100 hidden md:block" style={{ background: "#fff8fc" }}>
        <div className="max-w-5xl mx-auto flex items-center">
          {settings.navItems.map((item) => (
            <div key={item.id} className="relative group"
              onMouseEnter={() => setOpenDropdown(item.id)}
              onMouseLeave={() => setOpenDropdown(null)}>
              <a href={item.href}
                className="flex items-center gap-1 px-5 py-3 text-sm text-pink-700 hover:text-pink-900 transition-colors whitespace-nowrap"
                style={{ borderBottom: "2px solid transparent" }}
                onMouseEnter={e => (e.currentTarget.style.borderBottomColor = "#ffcde9")}
                onMouseLeave={e => (e.currentTarget.style.borderBottomColor = "transparent")}>
                {item.label}
                {item.children && <i className="ri-arrow-down-s-line text-xs" />}
              </a>
              {item.children && openDropdown === item.id && (
                <div className="absolute top-full left-0 border border-pink-100 z-50 min-w-48" style={{ background: "#fff8fc" }}>
                  {item.children.map((child, ci) => (
                    <div key={ci} className="relative group/sub">
                      <a href={child.href}
                        className="flex items-center justify-between px-4 py-2 text-sm text-pink-700 hover:bg-pink-50 hover:text-pink-900 transition-colors whitespace-nowrap">
                        {child.label}
                        {child.children && <i className="ri-arrow-right-s-line text-xs" />}
                      </a>
                      {child.children && (
                        <div className="absolute top-0 left-full border border-pink-100 z-50 min-w-44 hidden group-hover/sub:block" style={{ background: "#fff8fc" }}>
                          {child.children.map((sub, si) => (
                            <a key={si} href={sub.href}
                              className="block px-4 py-2 text-sm text-pink-700 hover:bg-pink-50 hover:text-pink-900 transition-colors whitespace-nowrap">
                              {sub.label}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </nav>

      <nav className="w-full border-b border-pink-100 md:hidden flex items-center justify-between px-4 py-2" style={{ background: "#fff8fc" }}>
        <a href={settings.headerUrl} className="text-pink-700 font-bold text-lg">{settings.headerTitle}</a>
        <button onClick={() => setMobileOpen(!mobileOpen)} className="text-pink-600 p-2 cursor-pointer" aria-label="メニュー">
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>
      {mobileOpen && (
        <div className="md:hidden border-b border-pink-100 z-50" style={{ background: "#fff8fc" }}>
          {settings.navItems.map((item) => (
            <div key={item.id}>
              <a href={item.href} className="block px-5 py-3 text-sm text-pink-700 border-b border-pink-50 hover:bg-pink-50">{item.label}</a>
              {item.children?.map((child, ci) => (
                <a key={ci} href={child.href} className="block pl-8 pr-5 py-2 text-xs text-pink-400 border-b border-pink-50 hover:bg-pink-50">{child.label}</a>
              ))}
            </div>
          ))}
        </div>
      )}
    </header>
  );
}
